import { HTMLAttributes } from 'react';
import { IRegisterOutputProps } from '@xmanscript/useform/lib/@types';
import { cn } from '@/utils';
import { Switch } from '../Switch';

interface INameEditProps extends HTMLAttributes<HTMLDivElement> {
  registerProps: IRegisterOutputProps;
  name?: string;
}

export default function ToggleWithLabel({ name = 'unnamed', className, registerProps, ...props }: INameEditProps) {
  // Extract only the properties that are valid for the Switch component
  const { value, onChange, enable, id } = registerProps;

  return (
    <div className={cn('flex w-full items-center justify-between gap-5 pr-4', className)} {...props}>
      <p className="w-[6rem] text-[0.875rem] font-normal text-[#667085]">{name}</p>
      <Switch
        checked={value}
        onCheckedChange={onChange}
        disabled={!enable}
        id={id} />
    </div>
  );
}
